import jwtDecode from "jwt-decode";
import client from "./http-request";


const refreshAccessToken = async () => {
  const res = await client.get('/api/auth/refreshToken');
  if (!!res.data.accessToken) {
    localStorage.setItem('access_token', res.data.accessToken);
  }
};


const isJwtExpired = (jwt) => {
  if (!jwt) {
    return false;
  }

  // check if jwt is expired
  const jwtPayload = jwtDecode(jwt);
  // @ts-ignore
  return Date.now() >= jwtPayload.exp * 1000 ? true : false;
};

export const authUser = async (username, password) => {
  const res = await client.post("/api/v1/auth/login", {
    username: username,
    password: password,
  });

  if (res.data.accessToken) {
    localStorage.setItem("access_token", res.data.accessToken);
  }
};

export const isUserAuthenticated = async () => {
  const accessToken = localStorage.getItem("access_token");

  if (!accessToken) {
    return false;
  }

  // check if accessToken exists and is not expired
  if (isJwtExpired(accessToken)) {
    // check if accessToken can be refreshed through refreshToken in cookies
    try {
      await refreshAccessToken();
    } catch (error) {
      // console.log('TCL -> isUserAuthenticated -> error', error);
    }

    return false;
  }

  return true;
};
